import React, {Component} from 'react';
import {Row, Col} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendarAlt, faMapMarkerAlt } from '@fortawesome/pro-light-svg-icons'
import Moment from 'react-moment'

import styles from './SearchResult.css';

import Button from "../Button/Button"
import Headline from "../Headline/Headline";
import {color_orange} from "../../constants/colors";

export default class SearchResult extends Component {
    render() {

        const {data, fachgruppe, clickAction, iframe, iframePrefix} = this.props;

        return (
            <Row>
                <Col sm={2}></Col>
                <Col sm={8}>
                    <div className={styles.container}>
                        <div className={styles.photo} style={{backgroundImage: "url('" + data.profilepic +"')"}}>
                            <span className={styles.category}>{fachgruppe}</span>
                        </div>

                        <div className={styles.content}>
                            <h4 className={styles.name}>{data.name}</h4>

                            <div className={styles.infoWrapper}>
                                <div className={styles.info}>
                                    <div className={styles.labelWrapper}>
                                        <FontAwesomeIcon icon={faCalendarAlt} size="lg"/>
                                    </div>
                                    <div>
                                        <span>
                                            <Moment date={data.date} format="DD.MM.YYYY" />
                                            <br />
                                            <Moment date={data.date} format="HH:mm" /> Uhr
                                        </span>
                                    </div>
                                </div>

                                <div className={[styles.info, styles.infoLast].join(' ')}>
                                    <div className={styles.labelWrapper}>
                                        <FontAwesomeIcon icon={faMapMarkerAlt} size="lg"/>
                                    </div>
                                    <div>
                                        <span>{data.street} {data.housenumber}<br />{data.plz} {data.city}</span>
                                    </div>
                                </div>
                            </div>

                            <Button href={`${iframe ? '/iframe' : ''}` + "/termin/" + data.appointments_id + `${iframePrefix ? iframePrefix : ''}`} onClick={clickAction} pullRight>Termin buchen</Button>
                        </div>

                    </div>
                </Col>
                <Col sm={2}></Col>
            </Row>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/SearchResult/SearchResult.js